import { Login, Register, ForgetPassword } from '@app/auth';
import { CreateStory, ViewStory } from '@app/story';
import { HomeLayout } from '@app/Home';
import { Dashboard, Library, Profile, TadatoonLibrary } from '@app/Dashboard';
import NotFound from '@app/statics/NotFound';
import DashboardLayout from '@app/Dashboard/pages/dashboardLayout';
import PrivateRoute from './PrivateRoute';
import type { RouteObject } from 'react-router-dom';
import WhatIfPage from '@app/Dashboard/pages/whatif';
import MyChild from '@app/Dashboard/pages/myChild';
import WhatIfStoryPage from '@app/Dashboard/pages/whatif/whatIfStory';
import TellStoryPage from '@app/Dashboard/pages/tellStory';

const router: RouteObject[] = [
  {
    path: '/',
    element: <HomeLayout />,
    children: [
      {
        path: '/',
        element: <PrivateRoute component={Dashboard} title="Hello !" />,
      },
      {
        path: '/story',
        element: <CreateStory />,
      },

      {
        path: '/story/:id',
        element: <PrivateRoute component={ViewStory} title={'View Story'} />,
      },
      {
        path: '/login',
        element: <Login />,
      },
      {
        path: '/register',
        element: <Register />,
      },
      {
        path: '/forget-password',
        element: <ForgetPassword />,
      },
      {
        path: '/*',
        element: <NotFound />,
      },
    ],
  },
  {
    path: '/dashboard',
    element: <PrivateRoute component={DashboardLayout} />,
    children: [
      {
        path: '/dashboard',
        element: <PrivateRoute component={Dashboard} title="Hello !" />,
      },
      {
        path: '/dashboard/library',
        element: <PrivateRoute component={Library} title="My Library" />,
      },
      {
        path: '/dashboard/TadatoonLibrary',
        element: (
          <PrivateRoute component={TadatoonLibrary} title="Tadatoon Library" />
        ),
      },
      {
        path: '/dashboard/profile',
        element: <PrivateRoute component={Profile} title="Profile" />,
      },
      {
        path: '/dashboard/my-child',
        element: <PrivateRoute component={MyChild} title="My Childrens" />,
      },
      {
        path: '/dashboard/whatif',
        element: <WhatIfPage />,
      },
      {
        path: '/dashboard/whatif-story/:id',
        element: <WhatIfStoryPage />,
      },
      {
        path: '/dashboard/tell-story',
        element: <TellStoryPage />,
      },
    ],
  },
];
export default router;
